import { selectUserFormData } from "app/redux/selector";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectDraftBoardForm } from "../../../components/Settings/redux/selector";
import { useBoardsActions } from "../../../components/useBoardsActions";
import { selectSelectedTickets } from "../../../redux/selector";
import { actions as actionsTicket } from "../../../redux/slice";
import { GroupAction } from "../../../types";
import { selectTicketGroups } from "../../Tickets/redux/selector";
import { ticketGroupsActions } from "../../Tickets/redux/slice";
import { TicketGroup } from "../../Tickets/types";
import AddTicketGroupModal from "./AddTicketGroupModal";
import ColumnGroupActionsDropdown from "./ColumnGroupActionsDropdown";
import GroupDeleteModal from "./GroupDeleteModal";

interface GroupActionProps {
  group: TicketGroup;
  onAddNewGroup?: () => void;
}

const ColumnGroupActions: React.FC<GroupActionProps> = ({
  group,
  onAddNewGroup,
}) => {
  const dispatch = useDispatch();
  const selectedList = useSelector(selectSelectedTickets);

  const { _id: boardId, groupBy } = useSelector(selectDraftBoardForm);
  const { selectedProjectId } = useSelector(selectUserFormData);
  const { updateBoardsGroupsJson } = useBoardsActions(selectedProjectId);
  const [isEditModalOpen, setIsEditModalOpen] = useState({
    action: false,
    hasEdit: false,
  });
  const [isRemoveGroup, setIsRemoveGroup] = React.useState(false);
  const isSelected =
    selectedList?.id?.length > 0 && selectedList.group.includes(group?._id);
  const onAddNewGroupHandler = () => {
    setTimeout(() => onAddNewGroup?.(), 0);
  };

  const handleSelect = (type) => {
    switch (type) {
      case GroupAction.COLLAPSE:
        return onCollapseGroup();
      case GroupAction.SELECT_ALL:
        return handleSelectAll();
      case GroupAction.Un_SELECT_ALL:
        return handleUnSelectAll();
      case GroupAction.HIDE:
        return onHideGroup();
      case GroupAction.EDIT:
        return onEditGroup();
      case GroupAction.ADD_NEW_GROUP:
        return onAddNewGroupHandler();
      case GroupAction.REMOVE:
        return setIsRemoveGroup(true);

      default:
        break;
    }
  };

  const onCollapseGroup = () => {
    dispatch(
      ticketGroupsActions.updateGroupActions({ ...group, isCollapse: true }),
    );
    updateBoardsGroupsJson(boardId, () => {});
  };
  const onHideGroup = () => {
    dispatch(
      ticketGroupsActions.updateGroupActions({ ...group, isVisible: false }),
    );
    updateBoardsGroupsJson(boardId, () => {});
  };

  const onUnHideGroup = (group: TicketGroup) => {
    dispatch(
      ticketGroupsActions.updateGroupActions({
        ...group,
        isVisible: true,
      }),
    );

    updateBoardsGroupsJson(boardId, () => {});
  };

  const onEditGroup = () => {
    dispatch(
      ticketGroupsActions.setGroupFormValues({
        name: "name",
        value: group.name,
      }),
    );
    dispatch(
      ticketGroupsActions.setGroupFormValues({
        name: "description",
        value: group.description ?? "",
      }),
    );
    setIsEditModalOpen({ action: true, hasEdit: true });
  };
  const onDeleteGroup = () => {
    dispatch(ticketGroupsActions.deleteGroup(group._id));
    updateBoardsGroupsJson(boardId, () => {});
  };
  const handleSelectAll = () => {
    dispatch(actionsTicket.toggleSelectTicketByGroup(group));
  };
  const handleUnSelectAll = () => {
    dispatch(actionsTicket.toggleSelectTicketByGroup(group));
  };
  const groupData = useSelector(selectTicketGroups);
  const hiddenGroups = groupData?.filter((g) => !g?.isVisible) ?? [];

  return (
    <div className=" relative">
      <ColumnGroupActionsDropdown
        handleSelect={handleSelect}
        isSelected={isSelected}
        groupBy={groupBy}
        hiddenGroups={hiddenGroups}
        setIsGroupModalOpen={(val) =>
          setIsEditModalOpen({ action: true, hasEdit: false })
        }
        onUnHideGroup={onUnHideGroup}
        groupId={group._id}
      />

      {isEditModalOpen.action && (
        <AddTicketGroupModal
          onClose={() => setIsEditModalOpen({ action: false, hasEdit: false })}
          isEditGroup={isEditModalOpen.hasEdit}
          onSave={(name, description) => {
            dispatch(
              ticketGroupsActions.updateGroupActions({
                ...group,
                name,
                description,
              }),
            );
            updateBoardsGroupsJson(boardId, () => {});
            setIsEditModalOpen({ action: false, hasEdit: false });
          }}
        />
      )}
      {isRemoveGroup && (
        <GroupDeleteModal
          componentName={group.name}
          onSubmit={onDeleteGroup}
          onClose={() => setIsRemoveGroup(false)}
          loading={false}
        />
      )}
    </div>
  );
};

export default ColumnGroupActions;
